<template>
	<div class="l-body">
		<top/>
	<div class="wrap login_bg">
	<div class="login zheng">
	<div class="login_dl" style="height: 490px !important;">
	<div class="dlfs">
	<h1>选择登录方式</h1>
	<a href="http://kfmu.zhaouc.com/" target="_blank">奇迹MU主账号登录</a>
	<a href="http://kfmu_wg.zhaouc.com/" target="_blank">奇迹MU（Wegame）登陆</a>
	<a href="http://kfsun.zhaouc.com/" target="_blank">奇迹世界主账号登录</a>
	<a @click='$router.push({path:"/login"})'>一号通登录</a>
	<a @click='$router.push({path:"/vlogin"})'>奇迹MU（VIP区）登录</a>
	<a @click='$router.push({path:"/rologin"})'>仙境传说起源（普隆德拉）登录</a>
	<a @click='$router.push({path:"/mlogin"})'>魔力宝贝手机验证码登录</a>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>
<script>
	import top from '@/components/top1.vue'
	export default {
	  name: 'chooselogin',
	  components: {
	    top
	  },
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/chooselogin.vue